import BankAccountPages from './BankAccountsPage';

export default BankAccountPages;
